import React from 'react';
import cm from 'classnames';

import styles from './Tabs.module.scss';

export const Tabs = ({
  tabs,
  active,
  onChange,
  className,
}: {
  tabs: { key: string; title: string; hidden?: boolean }[];
  active: string;
  onChange: (value: string) => void;
  className?: string;
}): React.ReactElement => (
  <ul className={cm(styles.tabs, className)}>
    {tabs.map((tab, index) => (
      <li
        key={index}
        className={cm(styles.tab, { [styles.active]: tab.key === active, [styles.hidden]: tab.hidden })}
        onClick={() => onChange(tab.key)}
      >
        {tab.title}
      </li>
    ))}
  </ul>
);
